import { render, staticRenderFns } from "./promotions-form.view.vue?vue&type=template&id=b9a50324&scoped=true"
import script from "./promotions-form.view.vue?vue&type=script&lang=ts"
export * from "./promotions-form.view.vue?vue&type=script&lang=ts"
import style0 from "./promotions-form.view.vue?vue&type=style&index=0&id=b9a50324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a50324",
  null
  
)

export default component.exports